import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  useToast,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Flex,
  Text,
  Spinner,
  Select,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { useState, useCallback, useEffect, useRef } from "react";
import OptionsService from "../Os/OptionsOsService";
import {
  buildCreateOptionPayload,
  buildUpdateOptionPayload,
  isNonEmptyName,
} from "./optionsRegistrationUtils";
import ModernPageShell from "../../components/layout/ModernPageShell";
import { getModernUi } from "../../components/layout/modernUi";

export default function CadastroOpcoesOs({ modern = false }) {
  const ui = getModernUi(modern);
  const toast = useToast();

  // --- Estados para Novos Cadastros ---
  const [newPriorityName, setNewPriorityName] = useState("");
  const [newOsStatusName, setNewOsStatusName] = useState("");
  const [newServiceTypeName, setNewServiceTypeName] = useState("");
  const [newTeamTypeName, setNewTeamTypeName] = useState("");
  const [newRoleName, setNewRoleName] = useState("");
  const [newProfileName, setNewProfileName] = useState("");
  const [newUserStatusName, setNewUserStatusName] = useState("");

  // --- Estados para Listagem de Opções (e o ID selecionado) ---
  const [priorities, setPriorities] = useState([]);
  const [selectedPriorityId, setSelectedPriorityId] = useState("");

  const [osStatuses, setOsStatuses] = useState([]);
  const [selectedOsStatusId, setSelectedOsStatusId] = useState("");

  const [serviceTypes, setServiceTypes] = useState([]);
  const [selectedServiceTypeId, setSelectedServiceTypeId] = useState("");

  const [teamTypes, setTeamTypes] = useState([]);
  const [selectedTeamTypeId, setSelectedTeamTypeId] = useState("");

  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState("");

  const [profiles, setProfiles] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState("");

  const [userStatuses, setUserStatuses] = useState([]);
  const [selectedUserStatusId, setSelectedUserStatusId] = useState("");

  // --- Estados para Carregamento da Listagem ---
  const [loadingPriorities, setLoadingPriorities] = useState(true);
  const [loadingOsStatuses, setLoadingOsStatuses] = useState(true);
  const [loadingServiceTypes, setLoadingServiceTypes] = useState(true);
  const [loadingTeamTypes, setLoadingTeamTypes] = useState(true);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [loadingProfiles, setLoadingProfiles] = useState(true);
  const [loadingUserStatuses, setLoadingUserStatuses] = useState(true);

  const {
    isOpen: isEditModalOpen,
    onOpen: onEditModalOpen,
    onClose: onEditModalClose,
  } = useDisclosure();
  const {
    isOpen: isDeleteDialogOpen,
    onOpen: onDeleteDialogOpen,
    onClose: onDeleteDialogClose,
  } = useDisclosure();
  const [editingOption, setEditingOption] = useState(null);
  const [editedName, setEditedName] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [deletingOption, setDeletingOption] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const cancelDeleteRef = useRef();

  // Função para buscar todas as opções
  const fetchOptions = useCallback(async () => {
    // Prioridades
    setLoadingPriorities(true);
    try {
      const data = await OptionsService.getOptionsByType("priority");
      setPriorities(data);
      setSelectedPriorityId("");
    } catch (error) {
      toast({
        title: "Erro ao carregar Prioridades",
        description:
          error.message || "Não foi possível carregar as prioridades.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingPriorities(false);
    }

    // Status da OS
    setLoadingOsStatuses(true);
    try {
      const data = await OptionsService.getOptionsByType("statusofservice");
      setOsStatuses(data);
      setSelectedOsStatusId("");
    } catch (error) {
      toast({
        title: "Erro ao carregar Status da OS",
        description:
          error.message || "Não foi possível carregar os status da OS.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingOsStatuses(false);
    }

    // Tipos de Serviço
    setLoadingServiceTypes(true);
    try {
      const data = await OptionsService.getOptionsByType("typeofservice");
      setServiceTypes(data);
      setSelectedServiceTypeId("");
    } catch (error) {
      toast({
        title: "Erro ao carregar Tipos de Serviço",
        description:
          error.message || "Não foi possível carregar os tipos de serviço.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingServiceTypes(false);
    }

    // Tipos de Equipe
    setLoadingTeamTypes(true);
    try {
      const data = await OptionsService.getOptionsByType("team");
      setTeamTypes(data);
      setSelectedTeamTypeId("");
    } catch (error) {
      toast({
        title: "Erro ao carregar Tipos de Equipe",
        description:
          error.message || "Não foi possível carregar os tipos de equipe.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingTeamTypes(false);
    }

    // Perfis de acesso (role)
    setLoadingProfiles(true);
    try {
      const data = await OptionsService.getOptionsByType("role");
      setProfiles(data);
      setSelectedProfileId("");
    } catch (error) {
      toast({
        title: "Erro ao carregar Perfis",
        description:
          error.message || "Não foi possível carregar os perfis de acesso.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingProfiles(false);
    }

    // Cargos (Employees)
    setLoadingRoles(true);
    try {
      const data = await OptionsService.getOptionsByType("employees");
      setRoles(data);
      setSelectedRoleId("");
    } catch (error) {
      toast({
        title: "Erro ao carregar Cargos",
        description: error.message || "Não foi possível carregar os cargos.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingRoles(false);
    }

    // Status do Usuário
    setLoadingUserStatuses(true);
    try {
      const data = await OptionsService.getOptionsByType("status");
      setUserStatuses(data);
      setSelectedUserStatusId("");
    } catch (error) {
      toast({
        title: "Erro ao carregar Status de Usuário",
        description:
          error.message || "Não foi possível carregar os status de usuário.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingUserStatuses(false);
    }
  }, [toast]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  const handleAddOption = useCallback(
    async (type, name, setNameState) => {
      if (!isNonEmptyName(name)) {
        toast({
          title: "Erro",
          description: `O nome do(a) ${type} não pode ser vazio.`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      try {
        await OptionsService.createOption(buildCreateOptionPayload(type, name));
        toast({
          title: "Sucesso",
          description: `${name} (${type}) adicionado(a) com sucesso!`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setNameState("");
        fetchOptions();
      } catch (error) {
        toast({
          title: `Erro ao adicionar ${type}`,
          description:
            error.message || `Não foi possível adicionar o(a) ${type}.`,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    },
    [toast, fetchOptions]
  );

  // --- Funções de Edição ---
  const handleEditSelectedOption = useCallback(
    (selectedId, optionsList) => {
      if (!Array.isArray(optionsList) || optionsList.length === 0) {
        console.error(
          "Erro: optionsList não é um array válido ou está vazio. Não é possível encontrar a opção."
        );
        toast({
          title: "Erro interno",
          description:
            "Lista de opções para edição está vazia ou inválida. Contate o suporte.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const optionToEdit = optionsList.find(
        (opt) => opt.optionsId === selectedId
      );

      if (optionToEdit) {
        setEditingOption(optionToEdit);
        setEditedName(optionToEdit.description);
        onEditModalOpen();
      } else {
        toast({
          title: "Erro",
          description:
            "Nenhuma opção selecionada para editar. Por favor, selecione uma opção válida. (Verifique o console para detalhes)",
          status: "warning",
          duration: 8000,
          isClosable: true,
        });
        console.error(
          `Falha ao encontrar opção para o ID selecionado: "${selectedId}". 
                       Verifique se o ID existe na 'optionsList' e se os tipos coincidem.
                       Lista de opções completa:`,
          optionsList
        );
      }
    },
    [onEditModalOpen, toast]
  );

  const handleUpdateOption = async () => {
    if (!isNonEmptyName(editedName)) {
      toast({
        title: "Erro",
        description: "O nome não pode ser vazio.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!editingOption) return;

    setIsUpdating(true);
    try {
      const payload = buildUpdateOptionPayload(editingOption, editedName);
      await OptionsService.updateOption(payload);

      toast({
        title: "Sucesso",
        description: "Opção atualizada com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      onEditModalClose();
      fetchOptions();
    } catch (error) {
      toast({
        title: "Erro ao atualizar opção",
        description: error.message || "Não foi possível atualizar a opção.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDeleteSelectedOption = useCallback(
    (selectedId, optionsList) => {
      if (!Array.isArray(optionsList) || optionsList.length === 0) {
        toast({
          title: "Erro interno",
          description: "Lista de opções para exclusão está vazia ou inválida.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const optionToDelete = optionsList.find(
        (opt) => opt.optionsId === selectedId
      );

      if (optionToDelete) {
        setDeletingOption(optionToDelete);
        onDeleteDialogOpen();
      } else {
        toast({
          title: "Erro",
          description: "Nenhuma opção selecionada para excluir.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      }
    },
    [onDeleteDialogOpen, toast]
  );

  const handleConfirmDelete = async () => {
    if (!deletingOption) return;

    setIsDeleting(true);
    try {
      await OptionsService.deleteOption(deletingOption.optionsId);
      toast({
        title: "Sucesso",
        description: "Opção excluída com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      onDeleteDialogClose();
      setDeletingOption(null);
      fetchOptions();
    } catch (error) {
      toast({
        title: "Erro ao excluir opção",
        description:
          error.response?.data?.message ||
          error.message ||
          "Não foi possível excluir a opção.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDeleting(false);
    }
  };

  // Componente auxiliar para renderizar cada seção de gerenciamento com Select e botão de editar
  const OptionManagementSection = ({
    title,
    options,
    isLoading,
    selectedId,
    setSelectedId,
    handleEditFn,
    handleDeleteFn,
  }) => {
    return (
      <Box {...ui.card}>
        <Heading {...ui.sectionHeading}>
          {title}
        </Heading>
        {isLoading ? (
          <Flex justify="center" align="center" minHeight="100px">
            <Spinner size="lg" color="#C1272D" />
          </Flex>
        ) : options.length === 0 ? (
          <Text color="gray.500">Nenhum(a) {title} cadastrado(a) ainda.</Text>
        ) : (
          <>
            <FormControl mb={4}>
              <FormLabel>Selecione para editar ou excluir</FormLabel>
              <Select
                placeholder={`Selecione um(a) ${title
                  .toLowerCase()
                  .replace(" de os", "")
                  .replace(" de serviço", "")}`}
                value={selectedId}
                onChange={(e) => {
                  setSelectedId(e.target.value);
                }}
                {...ui.input}
              >
                {options.map((option) => (
                  <option key={option.optionsId} value={option.optionsId}>
                    {option.description ||
                      `[Nome Vazio - ID: ${option.optionsId}]`}
                  </option>
                ))}
              </Select>
            </FormControl>
            <Flex gap={3}>
              <Button
                bg="#C1272D"
                color="white"
                _hover={{ bg: "#a81f23" }}
                flex={1}
                onClick={() => {
                  handleEditFn(selectedId, options);
                }}
                isDisabled={!selectedId}
              >
                Editar
              </Button>
              <Button
                variant="outline"
                borderColor="#C1272D"
                color="#C1272D"
                _hover={{ bg: "#fff5f5" }}
                flex={1}
                onClick={() => {
                  handleDeleteFn(selectedId, options);
                }}
                isDisabled={!selectedId}
              >
                Excluir
              </Button>
            </Flex>
          </>
        )}
      </Box>
    );
  };

  const pageContent = (
    <>
      {!modern && (
        <Heading mb={8} textAlign="center" color="#C1272D">
          Cadastro e Gerenciamento de Opções do Sistema
        </Heading>
      )}

      <Heading {...ui.subHeading}>
        Adicionar Novas Opções
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8} mb={10}>
        {/* Formulários de Cadastro */}
        <Box {...ui.card}>
          <Heading {...ui.sectionHeading}>
            Nova Prioridade (OS)
          </Heading>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome da Prioridade</FormLabel>
            <Input
              placeholder="Ex: Urgente, Alta"
              value={newPriorityName}
              onChange={(e) => setNewPriorityName(e.target.value)}
              {...ui.input}
            />
          </FormControl>
          <Button
            bg="#C1272D"
            color="white"
            _hover={{ bg: "#a81f23" }}
            width="full"
            onClick={() =>
              handleAddOption("priority", newPriorityName, setNewPriorityName)
            }
          >
            Adicionar Prioridade
          </Button>
        </Box>

        <Box {...ui.card}>
          <Heading {...ui.sectionHeading}>
            Novo Status (Ordem de Serviço)
          </Heading>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome do Status da OS</FormLabel>
            <Input
              placeholder="Ex: Em Andamento, Concluído"
              value={newOsStatusName}
              onChange={(e) => setNewOsStatusName(e.target.value)}
              {...ui.input}
            />
          </FormControl>
          <Button
            bg="#C1272D"
            color="white"
            _hover={{ bg: "#a81f23" }}
            width="full"
            onClick={() =>
              handleAddOption(
                "statusofservice",
                newOsStatusName,
                setNewOsStatusName
              )
            }
          >
            Adicionar Status da OS
          </Button>
        </Box>

        <Box {...ui.card}>
          <Heading {...ui.sectionHeading}>
            Novo Tipo de Serviço (OS)
          </Heading>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome do Tipo de Serviço</FormLabel>
            <Input
              placeholder="Ex: Manutenção, Instalação"
              value={newServiceTypeName}
              onChange={(e) => setNewServiceTypeName(e.target.value)}
              {...ui.input}
            />
          </FormControl>
          <Button
            bg="#C1272D"
            color="white"
            _hover={{ bg: "#a81f23" }}
            width="full"
            onClick={() =>
              handleAddOption(
                "typeofservice",
                newServiceTypeName,
                setNewServiceTypeName
              )
            }
          >
            Adicionar Tipo de Serviço
          </Button>
        </Box>

        <Box {...ui.card}>
          <Heading {...ui.sectionHeading}>
            Novo Tipo de Equipe (OS)
          </Heading>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome do Tipo de Equipe</FormLabel>
            <Input
              placeholder="Ex: Interna, Externa"
              value={newTeamTypeName}
              onChange={(e) => setNewTeamTypeName(e.target.value)}
              {...ui.input}
            />
          </FormControl>
          <Button
            bg="#C1272D"
            color="white"
            _hover={{ bg: "#a81f23" }}
            width="full"
            onClick={() =>
              handleAddOption("team", newTeamTypeName, setNewTeamTypeName)
            }
          >
            Adicionar Tipo de Equipe
          </Button>
        </Box>

        <Box {...ui.card}>
          <Heading {...ui.sectionHeading}>
            Novo Perfil (acesso)
          </Heading>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome do perfil</FormLabel>
            <Input
              placeholder="Ex: SUPERVISOR, AUDITOR"
              value={newProfileName}
              onChange={(e) => setNewProfileName(e.target.value)}
              {...ui.input}
            />
          </FormControl>
          <Button
            bg="#C1272D"
            color="white"
            _hover={{ bg: "#a81f23" }}
            width="full"
            onClick={() =>
              handleAddOption("role", newProfileName, setNewProfileName)
            }
          >
            Adicionar Perfil
          </Button>
        </Box>

        <Box {...ui.card}>
          <Heading {...ui.sectionHeading}>
            Novo Cargo (função do colaborador)
          </Heading>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome do Cargo</FormLabel>
            <Input
              placeholder="Ex: Técnico, Gerente"
              value={newRoleName}
              onChange={(e) => setNewRoleName(e.target.value)}
              {...ui.input}
            />
          </FormControl>
          <Button
            bg="#C1272D"
            color="white"
            _hover={{ bg: "#a81f23" }}
            width="full"
            onClick={() =>
              handleAddOption("employees", newRoleName, setNewRoleName)
            }
          >
            Adicionar Cargo
          </Button>
        </Box>

        <Box {...ui.card}>
          <Heading {...ui.sectionHeading}>
            Novo Status (Usuário)
          </Heading>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome do Status do Usuário</FormLabel>
            <Input
              placeholder="Ex: Ativo, Inativo"
              value={newUserStatusName}
              onChange={(e) => setNewUserStatusName(e.target.value)}
              {...ui.input}
            />
          </FormControl>
          <Button
            bg="#C1272D"
            color="white"
            _hover={{ bg: "#a81f23" }}
            width="full"
            onClick={() =>
              handleAddOption("status", newUserStatusName, setNewUserStatusName)
            }
          >
            Adicionar Status do Usuário
          </Button>
        </Box>
      </SimpleGrid>

      <Heading {...ui.subHeading} mt={10}>
        Gerenciar Opções Existentes
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
        {/* Seções de Gerenciamento de Opções com Select e Botão de Editar */}
        <OptionManagementSection
          title="Prioridades de OS"
          options={priorities}
          isLoading={loadingPriorities}
          selectedId={selectedPriorityId}
          setSelectedId={setSelectedPriorityId}
          handleEditFn={handleEditSelectedOption}
          handleDeleteFn={handleDeleteSelectedOption}
        />
        <OptionManagementSection
          title="Status de Ordem de Serviço"
          options={osStatuses}
          isLoading={loadingOsStatuses}
          selectedId={selectedOsStatusId}
          setSelectedId={setSelectedOsStatusId}
          handleEditFn={handleEditSelectedOption}
          handleDeleteFn={handleDeleteSelectedOption}
        />
        <OptionManagementSection
          title="Tipos de Serviço de OS"
          options={serviceTypes}
          isLoading={loadingServiceTypes}
          selectedId={selectedServiceTypeId}
          setSelectedId={setSelectedServiceTypeId}
          handleEditFn={handleEditSelectedOption}
          handleDeleteFn={handleDeleteSelectedOption}
        />
        <OptionManagementSection
          title="Tipos de Equipe de OS"
          options={teamTypes}
          isLoading={loadingTeamTypes}
          selectedId={selectedTeamTypeId}
          setSelectedId={setSelectedTeamTypeId}
          handleEditFn={handleEditSelectedOption}
          handleDeleteFn={handleDeleteSelectedOption}
        />
        <OptionManagementSection
          title="Perfis de acesso"
          options={profiles}
          isLoading={loadingProfiles}
          selectedId={selectedProfileId}
          setSelectedId={setSelectedProfileId}
          handleEditFn={handleEditSelectedOption}
          handleDeleteFn={handleDeleteSelectedOption}
        />
        <OptionManagementSection
          title="Cargos"
          options={roles}
          isLoading={loadingRoles}
          selectedId={selectedRoleId}
          setSelectedId={setSelectedRoleId}
          handleEditFn={handleEditSelectedOption}
          handleDeleteFn={handleDeleteSelectedOption}
        />
        <OptionManagementSection
          title="Status de Usuário"
          options={userStatuses}
          isLoading={loadingUserStatuses}
          selectedId={selectedUserStatusId}
          setSelectedId={setSelectedUserStatusId}
          handleEditFn={handleEditSelectedOption}
          handleDeleteFn={handleDeleteSelectedOption}
        />
      </SimpleGrid>

      {/* Modal de Edição de Opção */}
      <Modal isOpen={isEditModalOpen} onClose={onEditModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#C1272D">
            Editar Opção:{" "}
            {editingOption?.type === "statusofservice"
              ? "Status da OS"
              : editingOption?.type === "typeofservice"
              ? "Tipo de Serviço"
              : editingOption?.type === "priority"
              ? "Prioridade"
              : editingOption?.type === "team"
              ? "Tipo de Equipe"
              : editingOption?.type === "role"
              ? "Perfil"
              : editingOption?.type === "employees"
              ? "Cargo"
              : editingOption?.type === "status"
              ? "Status de Usuário"
              : editingOption?.type}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Nome</FormLabel>
              <Input
                value={editedName}
                onChange={(e) => setEditedName(e.target.value)}
                placeholder="Novo nome"
                borderColor="#625752"
                focusBorderColor="#C1272D"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="outline"
              borderColor="#625752"
              color="#625752"
              _hover={{ bg: "#f4f4f4" }}
              mr={3}
              onClick={onEditModalClose}
            >
              Cancelar
            </Button>
            <Button
              bg="#C1272D"
              color="white"
              _hover={{ bg: "#a81f23" }}
              onClick={handleUpdateOption}
              isLoading={isUpdating}
            >
              Salvar Alterações
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <AlertDialog
        isOpen={isDeleteDialogOpen}
        leastDestructiveRef={cancelDeleteRef}
        onClose={onDeleteDialogClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold" color="#C1272D">
              Excluir opção
            </AlertDialogHeader>
            <AlertDialogBody>
              Tem certeza que deseja excluir{" "}
              <strong>{deletingOption?.description}</strong>? Essa ação não
              pode ser desfeita.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button
                ref={cancelDeleteRef}
                onClick={onDeleteDialogClose}
                isDisabled={isDeleting}
              >
                Cancelar
              </Button>
              <Button
                bg="#C1272D"
                color="white"
                _hover={{ bg: "#a81f23" }}
                onClick={handleConfirmDelete}
                ml={3}
                isLoading={isDeleting}
              >
                Excluir
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );

  if (modern) {
    return (
      <ModernPageShell
        title="Cadastro de opções"
        subtitle="Gerencie prioridades, status, tipos de serviço, equipes, perfis e cargos do sistema."
        eyebrow="Configurações"
      >
        {pageContent}
      </ModernPageShell>
    );
  }

  return (
    <Box p={8} maxWidth="1200px" margin="auto" mt={8}>
      {pageContent}
    </Box>
  );
}
